var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"loading_status"}},[_c('div',{staticClass:"loading_status"},[_c('img',{attrs:{"src":require("../assets/image/loading.png"),"alt":""}}),_c('div',[_vm._v("加载中...")])])])
}]

export { render, staticRenderFns }